import { getCountry } from '@iwIntlProvider/CountryProvider';
import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';

import { isFlexi24Duration } from '../../myAccount/flexi24/getIsFlexi24Duration';
import {
    FLEXI_24_PRODUCT_TYPE,
    FLEXI_LOAN_PRODUCT_TYPE
} from '../../myAccount/multiLoanDashboard/accountsSelector';

export const APPLICATION_STATUS_OPEN = 'open';
export const APPLICATION_STATUS_OFFERED = 'offered';
export const APPLICATION_STATUS_DECLINED = 'declined';

export function getApplicationStatus(state: RootState) {
    return _.get(state, 'api.application.data.status');
}

export function hasApplicationWithProductType(
    state: RootState,
    urlProductType: string
) {
    const application = getApplicationProductType(state) === urlProductType;
    if (urlProductType === FLEXI_24_PRODUCT_TYPE && !application) {
        return (
            getApplicationProductType(state) === FLEXI_LOAN_PRODUCT_TYPE &&
            isFlexi24Duration(getApplicationDuration(state))
        );
    }
    if (
        urlProductType === FLEXI_LOAN_PRODUCT_TYPE &&
        application &&
        getApplicationProductType(state) === FLEXI_LOAN_PRODUCT_TYPE &&
        isFlexi24Duration(getApplicationDuration(state)) &&
        getCountry() !== 'DE'
    ) {
        return false;
    }
    return getApplicationProductType(state) === urlProductType;
}

function getApplicationProductType(state: RootState) {
    return _.get(
        state,
        'api.application.data.requested_products[0].suggested_product.product_type'
    );
}

function getApplicationDuration(state: RootState) {
    return _.get(
        state,
        'api.application.data.requested_products[0].suggested_product.duration'
    );
}
